<div class="navMenu" data-test-id="sidebar-menu">
  @if (showSanta) {
    <img class="navMenu__img" src="../../../assets/images/connect-christmas/logo-christmas.png" />
  } @else {
    <img class="navMenu__img" src="../../../assets/images/Techspert_Logo_horizontal.png" />
  }

  <div class="navMenu__list">
    @for (route of routes; track route) {
      <app-nav-menu-link class="nav-list-item" [route]="route"></app-nav-menu-link>
    }
  </div>
  <div class="navMenu__footer">
    <button matButton="filled" color="accent" (click)="logout()">Logout</button>
  </div>
</div>
